import React from "react";
import usePayouts from "./usePayouts";
import {NavLink} from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import MDBox from "../../../../../components/MDBox";
import DataTable from "../../../../../components/DataTable/DataTable";
import {API_URL, COLOR_SECONDARY} from "../../../../../config";
import {renderCurrency} from "../../../../../helpers/helpers";
import moment from "moment";
import DateFilter from "../../../../../components/DateFilter/DateFilter";

const Payouts = ({id}) => {
    const {actions, renderStatusChip} = usePayouts();

    return (
            <MDBox mt={2} sx={{padding: 2, borderStyle: 'solid', borderWidth: 1, borderColor: '#e2e2e2', borderRadius: 2}}>
                <MDBox mb={3}>
                        <DataTable
                            endpoint={`${API_URL}/payouts/doctor/${id}`}
                            title="Pagos"
                            description="Visualizar los pagos de comisiones."
                            sortBy="created_at"
                            sortDirection="desc"
                            filter={true}
                            actions={actions}
                            colData={[
                                {
                                    name: 'id',
                                    label: 'Folio',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <NavLink to={`/pagos/${tableMeta.rowData[0]}`}
                                                     key={`pago-${tableMeta.rowData[0]}`}
                                                     style={{fontWeight: 500, color: COLOR_SECONDARY, textDecoration: 'underline'}}
                                            >
                                                #POT-{value}
                                            </NavLink>
                                        )
                                    }
                                },
                                {
                                    name: 'total',
                                    label: 'Total',
                                    options: {
                                        customBodyRender: renderCurrency,
                                        filter: false
                                    }
                                },
                                {
                                    name: 'bank_account',
                                    label: 'Cuenta'
                                },
                                {
                                    name: 'voucher',
                                    label: 'Comprobante',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => {
                                            return <IconButton disabled={value === null} color="secondary" onClick={() => window.open(`${APP_URL}/storage/payouts/${value}`, "_blank")}>
                                                <RequestPageIcon />
                                            </IconButton>
                                        },
                                        filter: false
                                    }
                                },
                                {
                                    name: 'status',
                                    label: 'Estado',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => {
                                            return renderStatusChip(value)
                                        }
                                    }
                                },
                                {
                                    name: 'paid_at',
                                    label: 'Fecha de Pago',
                                    options: {
                                        filterType: 'custom',
                                        customFilterListOptions: {
                                            render: v => {
                                                if (v[0] && v[1]) return `Fecha Pago: ${moment(v[0]).format('YYYY-MM-DD')} - ${moment(v[1]).format('YYYY-MM-DD')}`;
                                                if (v[0]) return `Desde: ${moment(v[0]).format('YYYY-MM-DD')}`;
                                                if (v[1]) return `Hasta: ${moment(v[1]).format('YYYY-MM-DD')}`;
                                                return false;
                                            },
                                            update: (filterList, filterPos, index) => {
                                                if (filterPos === 0) filterList[index].splice(filterPos, 1, '');
                                                else filterList[index] = [];
                                                return filterList;
                                            }
                                        },
                                        filterOptions: {
                                            names: [],
                                            display: (filterList, onChange, index, column) => <DateFilter label="Fecha de Pago" filterList={filterList} column={column} onChange={onChange} index={index} />
                                        }
                                    }
                                },
                                {
                                    name: 'created_at',
                                    label: 'Fecha',
                                    options: {
                                        filterType: 'custom',
                                        customFilterListOptions: {
                                            render: v => {
                                                if (v[0] && v[1]) return `Fecha: ${moment(v[0]).format('YYYY-MM-DD')} - ${moment(v[1]).format('YYYY-MM-DD')}`;
                                                if (v[0]) return `Desde: ${moment(v[0]).format('YYYY-MM-DD')}`;
                                                if (v[1]) return `Hasta: ${moment(v[1]).format('YYYY-MM-DD')}`;
                                                return false;
                                            },
                                            update: (filterList, filterPos, index) => {
                                                if (filterPos === 0) filterList[index].splice(filterPos, 1, '');
                                                else filterList[index] = [];
                                                return filterList;
                                            }
                                        },
                                        filterOptions: {
                                            names: [],
                                            display: (filterList, onChange, index, column) => <DateFilter filterList={filterList} column={column} onChange={onChange} index={index} />
                                        }
                                    }
                                },
                            ]}
                        />
                </MDBox>
            </MDBox>
    );
};

export default Payouts;
